/**
 * @fileoverview User management + auth API service for ClubOS
 */
import apiClient from "../client";

export const userService = {
  // ── Users ─────────────────────────────────────────────────────────────────
  getUsers: (params) => apiClient.get("/users", { params }),
  createUser: (data) => apiClient.post("/users", data),
  updateUser: (id, data) => apiClient.put(`/users/${id}`, data),
  deactivateUser: (id) => apiClient.delete(`/users/${id}`),
  adminResetPassword: (id, newPassword) => apiClient.post(`/users/${id}/reset-password`, { newPassword }),

  // ── Auth ──────────────────────────────────────────────────────────────────
  changePassword: (currentPassword, newPassword, otp) =>
    apiClient.post("/auth/change-password", { currentPassword, newPassword, otp }),

  // ── OTP / MFA ─────────────────────────────────────────────────────────────
  sendOtp: (email) => apiClient.post("/auth/otp/send", { email }),
  verifyOtp: (email, otp) => apiClient.post("/auth/otp/verify", { email, otp }),
};
